// Webpack Imports
import * as bootstrap from 'bootstrap';

(function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call(document.querySelectorAll('.search-form'), (el) => {
		el.addEventListener('submit', function (e) {
			var search = el.querySelector('input');
			if (search.value.length < 1) {
				e.preventDefault();
				search.focus();
			}
		});
	});

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new bootstrap.Popover(popoverTriggerEl, {
			trigger: 'focus',
		});
	});

	var preSetFilter = document.querySelector('.filtered-items-filter a');
	if (preSetFilter) {
		document.querySelector('.filtered-items-filter a').classList.add('active');
	}

	document.querySelectorAll('.filtered-items-filter a').forEach((el) => el.addEventListener('click', (e) => {
		var tmpActive= el.parentNode.querySelector('.active');
		if (el !== tmpActive) {
			tmpActive.classList.remove('active');
		}
		el.classList.add('active')
	}));
})();

/*
const bs5LightboxOptions = {
	//keyboard: true,
	size: 'fullscreen'
};

document.querySelectorAll('.lightbox a').forEach((el) => el.setAttribute('data-gallery', 'lightboxgallery'));

document.querySelectorAll('.lightbox a').forEach((el) => el.addEventListener('click', (e) => {
	e.preventDefault();
	const lightbox = new Lightbox(el, bs5LightboxOptions);
	lightbox.show();
}));
*/
document.querySelectorAll('.lightbox a').forEach((el) => el.setAttribute('data-fslightbox', 'gallery'));

document.querySelectorAll('.lightbox a').forEach((el) => el.addEventListener('click', (e) => {
	e.preventDefault();
	const lightbox = new Lightbox(el, options);
	lightbox.show();
}));